import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    // lng: "nl",
    fallbackLng: "en-US",
    returnObjects: true,
    resources: {
      "en-US": {
        translation: {
          // Existing translations
          back: "Back",
          step: "Step",
          update: "Update",
          // ...

          pageTitle: {
            dashboard: "Dashboard",
            myEvents: "My Events",
            mySellers: "My Sellers",
            myGuest: "My Guests",
            myPromotions: "My Promotions",
            myProducts: "My Products",
            onsiteSales: "On-site Sales",
            accountSettings: "Settings",
            aiAssistant: "AI Assistant",
            getSupport: "Get Support",
            logout: "Logout",
            addNewEvent: "Add New Event",
          },

          authentication: {
            loginTitle: "Log in to your account",
            logout: "Logout",
          },

          inputFieldsTitle: {
            username: "Username",
            mobileNumber: "Mobile Number",
            number: "Number",
            phoneNumber: "Phone Number",
            email: "Email",
            contactEmail: "Contact Email",
            emailAddress: "Email Address",
            organizationEmail: "Organization Email",
            password: "Password",
            passwordPlaceholder: "Enter Password",
            rePasswordPlaceholder: "Re-enter Password",
            updatePassword: "Update password",
            forgotPassword: "Forgot Password",
            continue: "Continue",
            next: "Next",
            skip: "Skip",
            back: "Back",
            finish: "Finish",
            select: "Select",
            btnIndividual: "I'm Individual",
            yourLogo: "Your Logo",
            addLogo: "Add Logo",
            changePic: "Change Profile Pic.",
            hostName: "Host Name",
            hostNamePlaceholder: "Awesome Event Provider",
            orgName: "Organization Name",
            orgNamePlaceholder: "Awesome Event Company",
            hostAbout: "About The Host (Optional)",
            orgAbout: "About Your Organization (Optional)",
            continueWithGoogle: "Continue with google",
            resendSms: "Resend SMS",
            resendCode: "Resend code",
            wrongNumber: "Wrong Number",
            verifyNumber: "Verify Number",
            verifyEmail: "Verify Email",
            websiteOpt: "Website (Optional)",
            contactWebsiteOpt: "Contact Website",
            organizationWebsiteOpt: "Organization Website",
            websiteOptPlaceholder: "Your Website (Optional)",
            linkToSocialMedia: "Link to Social Media",
            optional: "(Optional)",
            verify: "Verify",
            ok: "OK",
            processing: "Processing...",
            cancel: "Cancel",
            fullName: "Full Name",
            addLocation: "Add Location",
            updateLocation: "Update Location",
            addSeller: "Add Seller",
            updateSeller: "Update Seller",
            updateSubscription: "Update Subscription",
            aboutOrg: "About Your Organization",
            contactAddress: "Contact Address",
            contactNumber: "Contact Number",
            payoutIntervalTitle: "Payout Interval",
            delayDaysTitle: "Delay Days",
            weeklyAnchorTitle: "Weekly Anchor",
            monthlyAnchorTitle: "Monthly Anchor",
            loading: "Loading...",
            view: "View",
            viewAll: "View all",
            viewMore: "View More",
            viewDetails: "View Details",
            viewHistory: "View History",
            close: "Close",
            locationName: "Location Name",
            businessAddress: "Business Address",
            addNewLocation: "Add New Location",
            edit: "Edit",
            delete: "Delete",
            uploadImage: "Upload Image",
          },

          linkDescription: {
            orContinueWith: "Or continue with",
            signUpLine: "Don't have an account yet?",
            imageTypeInfo: "JPG, GIF or PNG. 5MB max.",
            hostDetails: "Host Details",
            orgDetails: "Organization Details",
            tnpLine1: "By continuing you are indicating that you accept our ",
            tnpTermsOfUse: "Terms of Use",
            tnpLine2: "and our ",
            tnpPrivacyPolicy: "Privacy Policy",
            detailsVerification: "Details Verification",
            success: "Success",
            paymentProfile: "Payment Profile",
            // Password: "Password",
          },

          login: {
            errorRequiredOnBording: "Authenticated, but it seems like you haven't set up your business profile.",
          },

          signup: {
            signupTitle: "Create your account",
            errorOopsSignup: "Oops, there seems to be a problem...",
            alreadySignup: "Already have an account?",
            signupSuccessTitle: "Account created",
            signupSuccessSubTitle: "Your account is successfully created",
          },

          forgotPassword: {
            forgotTitle: "Recover",
            forgotSubTitle: "Enter your phone number associated with your account",
            verifyForgotTitle: "Verify Phone Number",
            verifyForgotSubTitle1: "Please enter the 4 digit code sent to ",
            verifyForgotSubTitle2: " through SMS",
            verifyResendTitle: "Didn't receive a code?",
          },

          onBording: {
            s1Title: "What type of host are you?",
            s1SubTitle: "Choose the option that best describes your situation as a host",
            hostBusiness: "Business",
            hostSubBusiness: "For companies or event organizers selling tickets under a brand or business name.",
            hostIndividual: "Individual",
            hostSubIndividual: "For individuals organizing personal events like workshops, parties, or local meetups.",
            hostNonProfit: "Non-Profit",
            hostSubNonProfit: "For organizations hosting community events, fundraisers, or educational sessions.",
            hostErrorMsg: "Please Choose your host type!",

            s2HostTitle: "Add host detail",
            s2OrgTitle: "Add your organization detail",
            s2SubHostTitle: "Set up your profile by adding key details about the host.",
            s2SubOrgTitle: "Set up your profile by adding key details about your organization.",

            s3Title: "Add your contact detail",
            s3SubTitle: "Allow your customers to reach you via any channel.",
            // Password: "Password",
          },

          // Account management translations
          account: {
            signIn: "Sign in",
            signUp: "Sign up",
            changePassword: "Change password",
            newPassword: "New password",
            account: "Account",
            organization: "Organization",
            onlinePayment: "Online Payment",
            billing: "Billing",
            loginInformationTitle: "Login Information",
            loginInformationSubTitle: "Permanent Login Information.",
            choosePasswordTitle: "Choose New password",
            authenticatedViaGoogle: "Authenticated via Google",
            personalInformationTitle: "Personal Information",
            personalInformationSubTitle: "Use a permanent address where you can receive mail.",
            changeProfileBtn: "Change Profile Pic.",
            organizationDetailsTitle: "Organization Details",
            organizationDetailsSubTitle: "Your Organization information to display for your customers.",
            contactDetailsTitle: "Contact Details",
            contactDetailsSubTitle: "Use a contact details where you can receive mail.",
            socialDetailsTitle: "Web and Social details",
            socialDetailsSubTitle: "Use web and social information to display it everywhere.",
            nameChangedModalTitle: "Alert!",
            nameChangedModalSubTitle: "Changing organization name will have an imapct on their entire {{businessType}} and, their clients might not be able to recognise them anymore with the older name and booking link.",
            stripePaymentSectionTitle: "Accept online payments via Stripe",
            stripePaymentSectionSubTitle: "Add your Stripe business account here to accept online payments, and get paid directly into your account. Manage all from a single app",
            enableStripePaymentsTitle: "Enable Payments via Stripe",
            enableStripePaymentsSubTitle: "By enabling this, you agree that all payments and refunds will be handled between you and your customer automatically via your Stripe account.",
            stripeAccountIdTitle: "Name on the Stripe Account Id",
            stripeAccountIdPlaceholder: "e.g. Bookzy Incorporation",
            stripeEmailAccountTitle: "Email on the Stripe Account",
            stripeAccountCountryTitle: "Country on the Stripe Account",
            enableStripePaymentsBtn: "Add my Stripe Account",
            enablePaymentMethodsTitle: "Enable Payment methods",
            enablePaymentMethodsSubTitle: "Select the payment methods you'd like to offer for online payments. A small processing fee applies to each method and is automatically deducted from each transaction. Consider factoring this into your ticket pricing.",
            paymentProcessingFeeSubTitle: "Payment processing fee: {{processingFee}}",
            payoutScheduleTitle: "Payout Schedule",
            availableForPayout: "Available for payout",
            payoutNow: "Pay out now",
            nextPayout: "Next payout scheduled for",
            nextPayoutEstimate: "Estimated. Stripe skips weekends and bank holidays, and only pays out a balance that has cleared.",
            noAvailableBalance: "Nothing to pay out yet. Recent sales stay pending until Stripe settles them.",
            payoutsNotEnabled: "Payouts aren't enabled on your Stripe account yet.",
            payoutStartedTitle: "Payout on its way",
            payoutScheduleSubTitle: "Choose how often you'd like to receive payouts. Some payout schedules may include a processing delay. Consider this when managing your cash flow.",
            subscriptionInformationTitle: "Subscription Information",
            subscriptionTableProduct: "Product",
            subscriptionTableFrequency: "Frequency",
            subscriptionTableNextinvoice: "Next invoice",
            tableActionHead: "Action",
            noSubscriptionFound: "No Subscription Found",
            tryForFree: "Try for Free",

          },

          organization: "Organization",
          onlinePayment: "Online payment",

          profile: {
            fullName: "Full name",
            dateOfbirth: "Date of birth",
            gender: "Gender",
            SelectGender: "Select Gender",
            male: "Male",
            female: "Female",
            other: "Other",
            address: "Address",
            city: "City",
            country: "Country",
            selectCountry: "Select Country",
            bio: "Bio",
            occupation: "Occupation",
            company: "Company",
            website: "Website",
          },

          billing: {
            billing: "Billing",
            invoice: "Invoice",
            invoiceSubTitle: "Your stripe subscription invoice.",
            invoiceTableHead: "Invoice number",
            amountTableHead: "Amount",
            invoicePeriodTableHead: "Invoice Period",
            detailedReportTableHead: "Detailed Report",
            downloadPDFBtn: "Download PDF",
            noInvoiceFoundMsg: "No Invoice Found",
          },

          myEvents: {
            createEvent: "Create New Event",
            addNewEvent: "Add a new event",
            exitCreateNewEvent: "Exit Create New Event",
            exitCreateNewEventSubTitle: "You are about to leave new event page. Leaving now will discard all entered information.",
            exitCreateNewEventBtn: "Save as Draft",
            exitCreateNewEventDiscardBtn: "Discard",
            eventName: "Event Name",
            tagLine: "Tag Line",
            eventType: "Event Type",
            selectEventType: "Select Event Type",
            aboutThisEvent: "About this event",
            aboutThisEventPlaceholder: "Add description about this event and what would participants of this event would experience...",
            aboutThisEventPlaceholder2: "Describe the vibe of your event and what guests will experience…",
            generating: "Generating...",
            generateByAIBtn: "Generate by AI",
            duration: "Duration",
            selectDuration: "Select Duration",
            whatToCarry: "What to carry (Optional)",
            eventSchedule: "Event Schedule",
            eventScheduleDates: "Event Schedule Date(s)",
            oneTime: "One Time",
            dailyRecurrent: "Daily Recurrent",
            weeklyRecurrent: "Weekly Recurrent",
            selectDays: "Select Days",
            eventDate: "Event date",
            startDate: "Start Date",
            time: "Time",
            where: "Where",
            endDate: "End Date",
            endDateHelperText: "One Time Classes have no End Date",
            from: "From",
            till: "Till",
            eventVenue: "Event Venue",
            venueAddress: "Venue Address",
            location: "Location",
            selectLocation: "Select Location",
            eventTickets: "Event Tickets",
            addTicketType: "Add Ticket Type",
            ticketType: "Ticket Type",
            price: "Price",
            capacity: "Capacity",
            totalCapacity: "Total Capacity:",
            ticketsSold: "Tickets Sold",
            totalTicketsSold: "Total Tickets Sold",
            costToBuyer: "Cost to buyer:",
            excluding: ", excluding",
            including: ", including",
            serviceFee: "service fee",
            yourPayout: "Your payout:",
            salesPeriod: "Sales period",
            salesPeriodHelper: "When this ticket type can be bought. Outside these dates it is hidden from the shop.",
            excludingGatewayFees: ", excluding payment gateway fees",
            dietarySplitTitle: "Dietary preferences",
            dietarySplitSubtitle: "Confirmed attendees only. Cancelled bookings are excluded.",
            dietarySplitAttendees: "{{total}} attendees",
            dietaryNotApplicable: "Dietary options not applicable",
            dietaryTotal: "Total",
            dietaryNotAsked: "Not asked {{notAsked}}",
            includedAddonRenameWarning: "Tickets already sold keep the name \"{{savedName}}\". Reports will show the old and new name as two separate items.",
            noTicketsCreated: "No tickets created",
            multipleTickets: "(Multiple Tickets)",
            deleteTicketTypeTitle: "Delete Ticket Type",
            deleteTicketTypeSubTitle: "Are you sure you want to delete this ticket type?",
            addTicket: "Add Ticket",
            add: "Add",
            tickets: "Tickets",
            startDateTimeBeforeEndTime: "Start date time must be before end date time",
            endDateTimeAfterStartTime: "End date time must be after start date time",
            minCapacityOfTicket: "The capacity of this ticket must be at least equal to the capacity already booked.",
            addonNameErrorMsg: 'Addon {{number}}: "Name" must be a required field',
            addonQtyErrorMsg: 'Addon {{number}}: "Qty" must be a positive number and minimum 1 qty required',
            ticketTypeHelperText: "Enter a ticket type differentiating pricing and access rights",
            priceTooltipTitle: "Please keep in mind platform and payment processing fee while pricing the ticket",
            free: "Free",
            paymentNotEnabledTitle: "Online Payment not enabled",
            paymentNotEnabledSubTitle: "Before you can start selling tickets for paid events you need to enable Online Payments.",
            paymentNotEnabledBtn: "Activate Online Payment",
            absorbServiceFee: "Absorb Service fee",
            minimumBookingQty: "No. of tickets per order",
            minimumBookingQtyHelperText: "Guests can only buy in multiples of this number. E.g. set to 2 for couple deals, 4+ for group deals.",
            capacityHelperText: "no. of tickets for this price",
            availableForSale: "Available for Sale",
            addIncludedItemsTitle: "Add Included Items",
            addIncludedItemsSubTitle: "(e.g. Free drink, T-shirt, meal)",
            addIncludedItemsSubTitle2: "Each item will generate a unique QR code to be scanned and redeemed at the venue.",
            addonName: "Addon Name",
            qty: "Qty",
            addMore: "+ Add More",
            advanceSettings: "Advance Settings",
            showEndDateOnShop: "Show the end date on the shop?",
            startTime: "Start Time",
            selectStartTime: "Select Start Time",
            general: "General",
            addons: "Addons",
            eventSettings: "Event Settings",
            schedule: "Schedule",
            reviewPublish: "Review & Publish",
            eventAddons: "Event Addons",
            addNewAddon: "Add New Addon",
            addonType: "Addon Type",
            selectAddonType: "Select Addon Type",
            description: "Description",
            addDescription: "Add Description",
            addonPhoto: "Addon photo",
            changeImage: "Change Image",
            addImage: "Add Image",
            addPhoto: "Add photo",
            changeBanner: "Edit Event Banner",
            addBanner: "Add Event Banner",
            maxQtyPerTicket: "Maximum Qty Allowed Per Ticket",
            priceOnline: "Price Online",
            priceAtVenue: "Price at Venue",
            priceAtVenueHelperText: "Price for add-on at location",
            addAddon: "Add Addon",
            addonCapacityMustBeBooking: "The capacity of this addon must be at least equal to the capacity already booked.",
            sameAddonType: "Same addon type is not allow!",
            removeAddonTitle: "Remove Addon",
            removeAddonDefaultMsg: "Are you sure you want to delete this{{type}}?",
            noAddonsCreated: "No addons created",
            freeCancellation: "Free Cancellation",
            periodBeforeCancellationAllowed: "Period before free cancellation is allowed:",
            cancellationCharge: "Cancellation Charge",
            noFreeCancellationAllowed: "No free cancellation allowed",
            privateEvent: "Private Event",
            privateEventTooltip: "Make this event private if you wish to let only selected people able to book this",
            privateEventMsg1: "Only customers with invite code will be able to book this event.",
            privateEventMsg2: "Invite code can be found in event details once created",
            orderLimit: "Order limit",
            maxTicketsAllowedPerOrder: "Max tickets allowed per order",
            maxTicketsAllowedPerOrderPlaceholder: "Number of max tickets per order",
            noLimitInSingleOrder: "no limit to number of tickets bought in single order",
            allowFreeCancellation: "Allow Free Cancellation",
            allowFreeCancellationText: "Allowing free cancellation recommended",
            bookingOnlyByInviteCode: "Booking only by Invite Code",
            qtyPerTicket: "Qty Per Ticket",
            addonsBooked: "Addons booked",
            privateEventStatus: "Private event",
            publicEventStatus: "Public event",
            eventCanBookedByAnybody: "This event can be booked by anybody",
            eventCanBookedByAnybody2: "Public event. This event can be booked by anybody",
            cancellationPolicyTitle: "Cancellation Policy",
            cancellationPolicyMsg1: "A cancellation charge of",
            cancellationPolicyMsg2: "applies for all cancellations. No refund will be provided if the cancellation is made within",
            cancellationPolicyMsg3: "of the event start time",
            freeCancelationNotAvailable: "Free cancelation not available.",
            maxTicketsPerOrderMsg1: "Customers can buy maximum",
            maxTicketsPerOrderMsg2: "tickets per order",
            maxTicketsPerOrderTitle: "Max tickets per order",
            createdEventStep1: "Created Event Format",
            createdEventStep2: "Created Pricing",
            createdEventStep3: "Creating Schedule(s) for this Event",
            savingInDraft: "Saving in Draft",
            creatingBookingLink: "Creating Booking Link",
            createdEventSucc1: "Congratulations!",
            createdEventSucc2: "Your Event is now ready for Booking",
            shareTheLinkBelowMsg: "Share the link below to let your customer book",
            copy: "Copy",
            copied: "Copied!",
            failedToCopy: "Failed to copy!",
            addAnotherEvent: "Add another event",
            gotoMyEvents: "Goto My Events",
            createPublish: "Create & Publish Event",
            orders: "Orders",
            addOns: "Add-ons",
            revenue: "Revenue",
            cancelingRefundMsg: "Canceling this event will refund respective fee for all the participants if already paid. Are you sure you want to cancel this class",
            cancelSingleSessionMsg: "You cannot cancel single session of this course",
            classInstanceIsCancelled: "This Class instance is cancelled",
            eventPageLink: "Event page link",
            classHasMultipleInstances: "This Class has multiple instances",
            venue: "Venue",
            payAtVenue: "Pay at Venue",
            actions: "Actions",
            editEventDetails: "Edit Event Details",
            changeSchedule: "Change Schedule",
            shareScanTicketToken: "Share scan ticket token",
            issueComplementaryTicket: "Issue complementary ticket",
            cancelEvent: "Cancel event",
            editEvent: "Edit event",
            pickAnotherInstance: "Pick another instance",
            preview: "Preview",
            imagePreview: "Image Preview",
            embedBookingWidget: "Embed booking widget",
            embedBookingWidgetCode: "Embed booking widget code",
            eventMetrics: "Event metrics",
            allSalesChannels: "All Sales Channels",
            totalAddonsSold: "Total Addons Sold",
            totalRevenue: "Total Revenue",
            ticketsRevenue: "Tickets Revenue",
            addonsRevenue: "Addons Revenue",
            commission: "Commission",
            eventActivityOverTime: "Event Activity Over Time",
            daily: "Daily",
            weekly: "Weekly",
            monthly: "Monthly",
            splitByTicketType: "Split by ticket type",
            ticketsBooked: "Tickets booked",
            splitByAddonsType: "Split by addons type",
            addonsSold: "Addons Sold",
            seeMore: "...see more",
            seeLess: "...see less",
            whatToCarryTitle: "What To Carry",
            cancelationPolicy: "Cancelation Policy",
            selectEndTime: "Select End Time",
            cancelSession: "Cancel Session",
            bookingLinkGeneratedTitle: "Booking link for {{eventName}}",
            bookingLinkGeneratedSubTitle: "Booking Link Generated",
            scanTicketTokenTitle: "Scan Ticket Token for {{eventName}}",
            scanTicketTokenSubTitle: "Share and use this code on Scan app to validate tickets",
            enterAtLeastOneQuantity: "Please enter at least one quantity.",
            reachedItsMaxCapacity: "The ticket type you have selected already reached its max capacity.",
            selectTicket: "Select ticket",
            quantity: "Quantity",
            issueTicket: "Issue ticket",
            salesDistribution: "Sales Distribution",
            ticketsDistribution: "Tickets Distribution",
            addonsDistribution: "Add-ons Distribution",
            revenueDistribution: "Revenue Distribution",
            commissionBreakdown: "Commission Breakdown",
            appliedThreshold: "Applied Threshold",
            tier: "Tier",
            rate: "Rate",
            of: "of",
            ticket: "Ticket",
            total: "Total",
            bonusEarned: "Bonus Earned",
            totalPayout: "Total Payout (Bonus + Commission)",
            editBasicInfo: "Edit Basic Info",
            editSettings: "Edit Settings",
            invitecode: "Invite Code:",
            sameSellerNotAllow: "Same seller cannot be use to difference sales channel",
            tierTicketsSoldErrorMsg: 'Tier {{number}}: "Tickets Sold" must be a positive number',
            tierFromErrorMsg: 'Tier {{number}}: "From" must be a positive number',
            tierCommissionErrorMsg: 'Tier {{number}}: "Commission Per Ticket" must be a valid number',
            tierToFromErrorMsg: 'Tier {{number}}: "To" must be greater than "From"',
            tierPreviousTierErrorMsg: 'Tier {{number}}: "Tickets Sold" must be greater than "Previous tier\'s thresholds"',
            tierOverlappingErrorMsg: 'Tier {{number}}: Overlapping range with previous tier',
            tierRangeMustContinueErrorMsg: 'Tier {{number}}: Range must continue from previous tier (expected "From" = {{to}})',
            completeThePreviousTierErrorMsg: 'Please complete the previous tier before adding a new one.',
            eventSalesChannel: "Event Sales Channel",
            addSalesChannel: "Add Sales Channel",
            campaign: "Campaign",
            selectCampaign: "Select a campaign",
            noCampaignsForEvent: "No campaigns for this event yet. Create one in Promotions to define the commission model.",
            howToAdd: "How do you want to add them?",
            modeInvite: "Send an invite",
            modeInviteDesc: "They set up their own account & payouts.",
            modeManaged: "Add directly (I'll manage)",
            modeManagedDesc: "Channel is created now; we email them their selling link. You settle commission manually.",
            selectSellers: "Select sellers",
            sellersSelected: "selected",
            addSellers: "Add sellers",
            sendInvites: "Send invites",
            sellersAdded: "Sellers added — their links were emailed.",
            invitesSent: "Invitations sent.",
            dashboardLinkSent: "Dashboard link sent.",
            manageInPromotions: "Manage sellers from My Promotions",
            copySellingLink: "Copy selling link",
            sendTrackLink: "Send 'Track my sales' link",
            sellerName: "Seller Name",
            commissionType: "Commission Type",
            channelType: "Channel Type",
            ref: "Ref:",
            noSalesChannelCreated: "No sales channel created",
            deleteSalesChannel: "Delete Sales Channel",
            deleteSalesChannelSubtitle: "Are you sure you want to delete this sales channel?",
            updateSalesChannel: "Update Sales Channel",
            salesChannelAdded: "Sales Channel Added",
            salesChannelAddedSubTitle: "Your sales channel has been successfully added.",
            seller: "Seller",
            selectSeller: "Select Seller",
            addBannerImageBtn: "Add Customize Banner",
            addBannerImageTitle: "Seller’s Event Banner",
            addBannerImageSubTitle: "This banner appears to customers when they purchase through your selling partner’s link",
            addCommissionModel: "Add Commission Model",
            commissionModelType: "Commission Model Type",
            flat: "Flat",
            tiered: "Tiered",
            thresholdBased: "Threshold Based",
            commissionModelTypeFlatHelper: "Single commission rate applied to all tickets sold.",
            commissionModelTypeTieredHelper: "Commission is calculated using progressive tiers, with each tier's rate applied only to the sales within that tier.",
            commissionModelTypeThresholdHelper: "Commission rate will be applied to all tickets sold based on corresponding threshold reached.",
            commissionUnitType: "Commission Unit Type",
            entervalue: "Enter value",
            thresholds: "Thresholds",
            tiers: "Tiers",
            greaterThan: "greater than",
            equalTo: "equal to",
            to: "To",
            min: "Min",
            max: "Max",
            addThreshold: "+ Add threshold",
            addTier: "+ Add tier",
            addBonus: "Add Bonus",
            bonusThreshold: "Bonus Threshold",
            bonusAmount: "Bonus Amount",
            noCommission: "No Commission",
            export: "Export",
            exportToExcel: "Export to Excel",
            exportToPDF: "Export to PDF",
          },

          myPromotions: {
            payViaStripe: "Pay via Stripe",
            payPromoter: "Pay promoter",
            payOnlineStripe: "Pay online (via Stripe)",
            markPaidOffline: "Mark as paid offline",
            noStripeHint: "Promoter has no connected Stripe account.",
            payoutRequests: "Payout requests",
            pendingRequests: "Pending requests",
            paymentsHistory: "Payments history",
            method: "Method",
            methodStripe: "Stripe",
            methodOffline: "Offline",
            initiatedBy: "Initiated by",
            initiationDate: "Initiation date",
            dateOfPayment: "Date of payment",
            paymentMethod: "Payment method",
            methodPaidOnline: "Paid online",
            paymentStatus: "Status",
            statusConfirmed: "Confirmed",
            statusPendingConfirmation: "Awaiting confirmation",
            statusDisputed: "Disputed",
            initPromoter: "Promoter",
            initOrganizer: "Organizer",
            initSellerRequest: "On request",
            reqRequested: "Requested",
            reqAmount: "Amount",
            reqStatus: "Status",
            reqAction: "Action",
            statusPending: "Pending",
            statusPaid: "Paid",
            statusDeclined: "Declined",
            pay: "Pay",
            decline: "Decline",
            syncStripePayouts: "Sync Stripe payouts",
            syncStripePayoutsHint: "Pull any completed Stripe payouts that aren't showing yet.",
            syncing: "Syncing…",
            payoutsSynced: "Payouts synced",
            payoutsUpToDate: "Already up to date.",
            payout: "Payout",
            viaStripe: "via Stripe",
            markPaidManually: "Mark as paid offline",
            stripePayoutSuccess: "Payout completed. It may take a moment to reflect.",
            stripePayoutCancelled: "Payout cancelled.",
            requestedPayout: "Requested",
            sellerRequestedPayout: "Seller requested payout",
            useActionsToSettle: "use the Payout button to settle",
            requestDeclined: "Payout request declined.",
            declineRequest: "Decline payout request",
            trackingOnly: "Tracking only",
            trackingOnlyHint: "Tracking only — sales are attributed to this channel, no commission or payout.",
            noCommissionTracking: "No commission (tracking only)",
            noCommissionHint: "Create a shareable tracking link (e.g. for Instagram) with no commission and no payout. Sales are still attributed to this channel.",
            createNewPromotion: "Create New Promotion",
            noPromotionsConfigured: "No promotions configured yet",
            addNewPromotion: "Add New Promotion",
            updatePromotion: "Update Promotion",
            selectEvent: "Select Event",
            offerLabel: "Offer Label",
            offerLabelPlaceholder: "e.g. Offer A, Early Bird Commission",
            maxSellers: "Max Sellers",
            enrolled: "Enrolled",
            viewPerformance: "View",
            invite: "Invite",
            addBanner: "Add customized banner",
            changeBanner: "Change customized banner",
            bannerSaved: "Banner saved.",
            bannerRemoved: "Banner removed.",
            ended: "Ended",
            endedHint: "This campaign has ended — edit it to reactivate before adding or enabling sellers.",
            pausedHint: "This campaign is paused — reactivate it before adding or enabling sellers.",
            alreadyAdded: "Already added",
            noEmail: "No email",
            noEmailHint: "Add an email to this seller to invite them",
            sellerSingular: "seller",
            scrollForMore: "Scroll for more",
            doubleClickPerformance: "Double-click to view performance",
            revenue: "Revenue",
            commission: "Commission",
            costPerTicket: "Cost/ticket",
            sellers: "Sellers",
            orders: "Orders",
            ticketRevenue: "Ticket rev.",
            addonRevenue: "Add-on rev.",
            unattributed: "unattributed",
            noData: "No performance data yet.",
            noSellersYet: "No sellers on this campaign yet.",
            payout: "Payout",
            commissionToPay: "To pay",
            paid: "Paid",
            outstanding: "Outstanding",
            showBreakdown: "Show breakdown",
            hideBreakdown: "Hide breakdown",
            payoutCommission: "Payout",
            markPaid: "Mark as paid",
            markedPaid: "Marked as paid.",
            markedPaidAwaitingConfirmation: "Payment recorded — waiting for seller to confirm receipt.",
            awaitingSellerConfirmation: "awaiting seller confirmation",
            awaitingSellerConfirmationHint: "The seller needs to confirm they received this payment. It will auto-confirm in 14 days.",
            pendingConfirmationLabel: "Pending",
            payoutSent: "Payout sent.",
            enableSeller: "Enable",
            disableSeller: "Disable",
            disabled: "disabled",
            actions: "Actions",
            viewDetails: "View details",
            hideDetails: "Hide details",
            after: "after",
            ticketsSold: "tickets sold",
            shareCampaign: "Share Campaign",
            sendInvites: "Send Invites",
            invitesSent: "Invitations Sent!",
            invitesSentCount: "invitation(s) sent successfully",
            selectSellersToInvite: "Select sellers to invite to this campaign. They will receive an email with event details and commission information.",
            noSellersFound: "No sellers with email found. Add sellers first.",
            sellersSelected: "seller(s) selected",
            inviteSellers: "Invite Sellers",
            active: "Active",
            paused: "Paused",
            campaign: "Campaign",
            clickToDisable: "Click to pause campaign",
            clickToEnable: "Click to activate campaign",
            perTicket: "per ticket",
            bonusAfter: "bonus after",
            tickets: "tickets",
            from: "From",
            until: "Until",
            startDate: "Start Date",
            endDate: "End Date",
            endDateBeforeStart: "End date must be after start date",
            inviteTracking: "Invite tracking",
            inviteSeller: "Seller",
            inviteEmail: "Email",
            inviteStatus: "Status",
            inviteSentOn: "Sent on",
            statusInvited: "Invited",
            statusAccepted: "Accepted",
            statusUsed: "Used",
            statusDeclined: "Declined",
            statusExpired: "Expired",
            loadingInvites: "Loading invites…",
            noTicketSales: "No ticket sales yet.",
            noAddonSales: "No add-ons sold.",
          },

          myschedule: {
            loadingSessionDetails: "Loading session details",
            noEventsConfigured: "No Events Configured",
            allTab: "All",
            publishedTab: "Published",
            draftsTab: "Drafts",
            cancelledtab: "Cancelled",
            pastTab: "Past",
            ticketsSold: "Tickets sold",
            markAsDraft: "Mark As Draft",
            markAsPublished: "Mark As Published",
            duplicatecreate: "Duplicate & create",
            noEventsAvailable: "No events available.",

          },

          bookings: {
            bookingTitle: "Bookings",
            recentBookingTitle: "Recent Bookings",
            totalBookingTitle: "Total Bookings",
            bookingId: "Booking ID",
            ticketsBought: "Tickets bought",
            amountPaid: "Amount paid",
            seatsBooked: "Seats booked",
            sendTikkie: "Send Tikkie",
            markAsPaid: "Mark as paid",
            cancelBooking: "Cancel booking",
            contact: "Contact",
            warning: "WARNING",
            changePaidStatusMsg: "Payment status cannot be changed back to unpaid. Are you sure you want to change status to paid?",
            cancelBookingMsg: "Cancellation will lead to full refund to the customer. Are you sure you want to cancel this booking?",
            cancelBookingDialogMsg: "Are you sure, you want to cancel booking?",
            removedParticipant: "Removed Participant",
            enabledYourPaymentSettings: "You have not enabled your payment settings. Do you want to set it now?",
            paymentLinkGeneratedTitle: "Payment link for {{eventName}}",
            paymentLinkGeneratedSubTitle: "Payment Link Generated",
            noBookingsYet: "No bookings yet",
            customerNeverPaidForIt: "Customer never paid for it",
            itWasAFreeService: "It was a free service",
            unknown: "UNKNOWN",
            bookingStatus: "Booking Status",
            bookingDate: "Booking Date",
            cancellationDate: "Cancellation Date",
            paymentStatus: "Payment Status",
            customerDetails: "Customer Details",
            purchaseDetails: "Purchase Details",
            activityBooked: "Activity Booked",
            activityStatus: "Activity Status",
            activityDate: "Activity Date",
            complementaryTicket: "(Complementary Ticket)",
            addonsBought: "Add-ons Bought",
            paymentMethod: "Payment Method",
            totalAmountPaid: "Total Amount Paid",
            includingVATFee: "Including VAT & Service Fee",
            yourPayoutDetails: "Your Payout Details",
            amountCustomerPaid: "Amount Customer Paid",
            platformServiceFee: "Platform Service Fee",
            paymentProcessingFee: "Payment Processing Fee",
            expectedPayout: "Expected Payout",
            beforePaymentProcessingFeeMsg: "(Before payment processing fee charged by Payment Gateway)",
            bookingDetailsSentTitle: "Booking details sent",
            bookingDetailsSentSubTitle: "An email with booking details and tickets has been sent to {{email}}",
            emailBookingDetails: "Email Booking Details",
            downloadBookingDetails: "Download Booking Details",
            yourRefundDetails: "Your Refund Details",
            yourCancellationFee: "Your Cancellation Fee",
            expectedRefund: "Expected Refund",
          },

          mySellers: {
            addNewSellers: "Add New Sellers",
            noSellersConfigured: "No Sellers Configured",
            copyOnBordingLink: "Copy OnBording Link",
            removeSeller: "Remove Seller",
            noServicesAreAvailable: "no services are available",
            sellersName: "Sellers Name",
            sellerType: "Seller Type",
            selectSellerType: "Select Seller Type",
            addPaymentAccount: "Add Payment Account",
            addPaymentAccountHelperTest: "A link to submit seller account information will be sent via email. Once completed, the status will update here automatically",
            paymentAccountDetails: "Payment Account Details",
            paymentAccountId: "Payment Account Id",
            status: "Status:",
            active: "Active",
            pending: "Pending",
            bankSccountDetailsMessage: "The account ID has been created but additional seller information and bank account details are still required.",
            resendOnboardingLink: "Resend Onboarding Link",
          },

          myGuests: {
            sendNotification: "Send Notification",
            promotionalEmail: "Promotional Email",
            sendEmail: "Send Email",
            guestList: "Guest List",
            title: "Title",
            promotionalImage: "Promotional Image",
            promotionalMessage: "Promotional Message",
            lengthExceedError: "Only 100 Emails are allowed",
            filterByEvent: "Filter by event name...",
          },

          mySubscription: {
            mySubscriptionTitle: "My Subscription",
            subscribSuccTitle: "You're all set",
            subscribSuccSubTitle: "Now let's get those events rolling!",
            startFree: "Start Free",
            startFreeTrial: "Start Your 30 days Trial",
            upgradeSubscription: "Upgrade subscription",
            currentSubscription: "Current subscription",
            addingHostDetail: "Adding your host details",
            addingOrgDetail: "Adding your organization details",
            freeTrialDetail: "Free trial",
          },

          dashboard: {
            dashboard: "Dashboard",
            customer: "Customer",
            activityBooked: "Activity booked",
          },

          // Existing error messages
          successes: {
            success: "Success!",
            subscribSuccessfully: "Your subscription is upgrade successfully",
            passwordSuccessfully: "Your password changed successfully",
            profileSuccessfully: "Your profile is updated successfully",
            businessProfileSuccessfully: "Your business profile is updated successfully",
            passwordSuccessfullyTitle: "Password Changed Successfully",
            passwordSuccessfullySubTitle: "Your password has been updated successfully.",
            paymentProfileChangedSuccTitle: "Profile Changed Successfully",
            paymentProfileChangedSuccSubTitle: "{{profileType}} profile successfully updated!",
            paymentProfileChangedSuccSubTitle2: "Payout schedule successfully updated!",
            paymentProfileAddedSuccTitle: "Well Done!",
            paymentProfileAddedSuccSubTitle: "Your customers will now be able to pay you directly to your account.",
            paymentProfileAddedSuccBtn: "Go back to Dashboard",
            goBackToLoginBtn: "Go back to Login",
          },

          // Existing error messages
          errors: {
            required: "Required!",
            isRequired: "{{field}} is required",
            invalid: "{{field}} is invalid",
            validationGeneralError: "Please fix errors below",
            // ... other existing errors

            // Additional account-related errors
            passwordSyntax: "Must Contain 8 Characters",
            passwordNOTMatch: "Passwords do NOT match",
            incorrectCode: "Incorrect Code, Please try again.",
            somethingIsWrong: "Something is wrong Please try again later.",
            aboutusMinLength: "Enter at least 5 letters to explain your {{businessName}}",
            invalidPhoneNumber: "Please enter valid phone number",
            invalidEmail: "Please enter correct email address",
            subscriptionWarningMsg: "You don't have an active subscription. If you need to access {{businessType}} business you will have to purchase/upgrade your subscription.",
            invalidWURL: "Please enter valid website URL",
            invalidFURL: "Please enter valid facebook URL",
            invalidIURL: "Please enter valid instagram URL",
            invalidYURL: "Please enter valid youtube URL",
            invalidLURL: "Please enter valid linkedIn URL",
            invalidTURL: "Please enter valid twitter URL",
            onePaymentMethodRequired: "At least one payment Method needs to be enabled.",
            connectWithStripeAcc: "Please connect with stripe account!",
            errorOccurredTitle: "An Error Occurred",
            errorOccurredSubTitle: "Failed to create Stripe account: Could not verify provided information. Please check your details and try again.",
            errorOccurredBtn: "Go back",
            delayMustBeMsg: "Minimum delay must be 7 days.",
            monthlyAnchorMustBeMsg: "Monthly anchor must be between 1 and 31.",
            decimalValueOnly: "Please enter decimal value!",
            endDateErrorMsg: "End Date has to be after Start Date",
            startDateErrorMsg: "Start Date must be in future",
            locationRequiredErrorMsg: "Location is required!",
            startApartMinuteErrorMsg: "Start and end times must be at least 1 minute apart.",
            aiServiceNotAvailable: "This service is not available",
            enterEventNameError: "Please enter an event name",
            failedToGenerateDescription: "Failed to generate description",
            errorAddingLocation: "Error adding location.",
            addAtLeastOnePrice: "Please add at least one price!",
            completePreAddons: "Please complete the previous addons details before adding a new one.",
            positiveQtyNumber: '"Qty" must be a positive number and minimum 1 qty required',
            enterValidEmail: "Please enter valid email",
            notAllowSameTicketType: "Same ticket type is not allow!",
            priceLessThanServiceFee: "Ticket price must be at least {{serviceFee}} to cover the service fee when absorbing.",
            venueCannotBeLessThanOnline: "Price at venue cannot be lower than online price.",
          },

          // Add other existing translations here...
        },
      },
      nl: {
        translation: {
          // Existing translations
          back: "Terug",
          step: "Stap",
          update: "Bijwerken",
          // ...

          pageTitle: {
            "dashboard": "Dashboard",
            "myEvents": "Mijn evenementen",
            "mySellers": "Mijn verkopers",
            "myGuest": "Mijn gasten",
            "myPromotions": "Mijn promoties",
            "myProducts": "Mijn producten",
            "onsiteSales": "Verkoop op locatie",
            "accountSettings": "Instellingen",
            "aiAssistant": "AI Assistent",
            "getSupport": "Ondersteuning krijgen",
            "logout": "Afmelden",
            "addNewEvent": "Nieuw evenement toevoegen"
          },

          authentication: {
            "loginTitle": "Log in op uw account",
            "logout": "Afmelden"
          },

          inputFieldsTitle: {
            "username": "Gebruikersnaam",
            "mobileNumber": "Mobiel nummer",
            "number": "Nummer",
            "phoneNumber": "Telefoonnummer",
            "email": "E-mail",
            "contactEmail": "Contact e-mail",
            "emailAddress": "E-mailadres",
            "organizationEmail": "E-mail van de organisatie",
            "password": "Wachtwoord",
            "passwordPlaceholder": "Voer wachtwoord in",
            "rePasswordPlaceholder": "Voer wachtwoord opnieuw in",
            "updatePassword": "Wachtwoord bijwerken",
            "forgotPassword": "Wachtwoord vergeten",
            "continue": "Doorgaan",
            "next": "Volgende",
            "skip": "Overslaan",
            "back": "Terug",
            "finish": "Voltooien",
            "select": "Selecteer",
            "btnIndividual": "Ik ben een individu",
            "yourLogo": "Uw logo",
            "addLogo": "Logo toevoegen",
            "changePic": "Profielfoto wijzigen",
            "hostName": "Naam van de host",
            "hostNamePlaceholder": "Geweldige evenementaanbieder",
            "orgName": "Naam van de organisatie",
            "orgNamePlaceholder": "Geweldige evenementenorganisatie",
            "hostAbout": "Over de host (optioneel)",
            "orgAbout": "Over uw organisatie (optioneel)",
            "continueWithGoogle": "Doorgaan met Google",
            "resendSms": "SMS opnieuw verzenden",
            "resendCode": "Code opnieuw verzenden",
            "wrongNumber": "Verkeerd nummer",
            "verifyNumber": "Nummer verifiëren",
            "verifyEmail": "E-mail verifiëren",
            "websiteOpt": "Website (optioneel)",
            "contactWebsiteOpt": "Contactwebsite",
            "organizationWebsiteOpt": "Website van de organisatie",
            "websiteOptPlaceholder": "Uw website (optioneel)",
            "linkToSocialMedia": "Koppelen aan sociale media",
            "optional": "(optioneel)",
            "verify": "Verifiëren",
            "ok": "OK",
            "processing": "Bezig met verwerken...",
            "cancel": "Annuleren",
            "fullName": "Volledige naam",
            "addLocation": "Locatie toevoegen",
            "updateLocation": "Locatie bijwerken",
            "addSeller": "Verkoper toevoegen",
            "updateSeller": "Verkoper bijwerken",
            "updateSubscription": "Abonnement bijwerken",
            "aboutOrg": "Over uw organisatie",
            "contactAddress": "Contactadres",
            "contactNumber": "Contactnummer",
            "payoutIntervalTitle": "Uitbetalingsinterval",
            "delayDaysTitle": "Vertragingsdagen",
            "weeklyAnchorTitle": "Wekelijkse ankerdag",
            "monthlyAnchorTitle": "Maandelijkse ankerdag",
            "loading": "Laden...",
            "view": "Bekijken",
            "viewAll": "Alles bekijken",
            "viewMore": "Meer bekijken",
            "viewDetails": "Details bekijken",
            "viewHistory": "Geschiedenis bekijken",
            "close": "Sluiten",
            "locationName": "Locatienaam",
            "businessAddress": "Zakelijk adres",
            "addNewLocation": "Nieuwe locatie toevoegen",
            "edit": "Bewerken",
            "delete": "Verwijderen",
            "uploadImage": "Afbeelding uploaden",
          },

          linkDescription: {
            "orContinueWith": "Of ga verder met",
            "signUpLine": "Heb je nog geen account?",
            "imageTypeInfo": "JPG, GIF of PNG. Maximaal 5 MB.",
            "hostDetails": "Details van de host",
            "orgDetails": "Details van de organisatie",
            "tnpLine1": "Door door te gaan geeft u aan dat u akkoord gaat met onze ",
            "tnpTermsOfUse": "Gebruiksvoorwaarden",
            "tnpLine2": "en ons ",
            "tnpPrivacyPolicy": "Privacybeleid",
            "detailsVerification": "Gegevensverificatie",
            "success": "Succes",
            "paymentProfile": "Betaalprofiel"
          },

          login: {
            "errorRequiredOnBording": "Geverifieerd, maar het lijkt erop dat u uw bedrijfsprofiel nog niet heeft ingesteld."
          },

          signup: {
            "signupTitle": "Maak uw account aan",
            "errorOopsSignup": "Oeps, er lijkt een probleem te zijn...",
            "alreadySignup": "Heeft u al een account?",
            "signupSuccessTitle": "Account aangemaakt",
            "signupSuccessSubTitle": "Uw account is succesvol aangemaakt"
          },

          forgotPassword: {
            "forgotTitle": "Herstellen",
            "forgotSubTitle": "Voer uw telefoonnummer in dat aan uw account is gekoppeld",
            "verifyForgotTitle": "Telefoonnummer verifiëren",
            "verifyForgotSubTitle1": "Voer de 4-cijferige code in die is verzonden naar ",
            "verifyForgotSubTitle2": " via SMS",
            "verifyResendTitle": "Geen code ontvangen?"
          },

          onBording: {
            "s1Title": "Wat voor soort host bent u?",
            "s1SubTitle": "Kies de optie die uw situatie als host het beste beschrijft",
            "hostBusiness": "Zakelijk",
            "hostSubBusiness": "Voor bedrijven of evenementenorganisatoren die tickets verkopen onder een merk- of bedrijfsnaam.",
            "hostIndividual": "Individu",
            "hostSubIndividual": "Voor personen die persoonlijke evenementen organiseren, zoals workshops, feesten of lokale bijeenkomsten.",
            "hostNonProfit": "Non-profit",
            "hostSubNonProfit": "Voor organisaties die gemeenschapsevenementen, inzamelingsacties of educatieve sessies organiseren.",
            "hostErrorMsg": "Kies uw hosttype alstublieft!",

            "s2HostTitle": "Voeg hostgegevens toe",
            "s2OrgTitle": "Voeg uw organisatiegegevens toe",
            "s2SubHostTitle": "Stel uw profiel in door belangrijke gegevens over de host toe te voegen.",
            "s2SubOrgTitle": "Stel uw profiel in door belangrijke gegevens over uw organisatie toe te voegen.",

            "s3Title": "Voeg uw contactgegevens toe",
            "s3SubTitle": "Laat uw klanten u via elk kanaal bereiken."
          },

          // Account management translations
          account: {
            "signIn": "Inloggen",
            "signUp": "Registreren",
            "changePassword": "Wachtwoord wijzigen",
            "newPassword": "Nieuw wachtwoord",
            "account": "Account",
            "organization": "Organisatie",
            "onlinePayment": "Online betaling",
            "billing": "Facturering",
            "loginInformationTitle": "Inloggegevens",
            "loginInformationSubTitle": "Permanente inloggegevens.",
            "choosePasswordTitle": "Kies een nieuw wachtwoord",
            "authenticatedViaGoogle": "Geverifieerd via Google",
            "personalInformationTitle": "Persoonlijke informatie",
            "personalInformationSubTitle": "Gebruik een permanent adres waar u post kunt ontvangen.",
            "changeProfileBtn": "Profielfoto wijzigen",
            "organizationDetailsTitle": "Organisatiegegevens",
            "organizationDetailsSubTitle": "Uw organisatiegegevens om weer te geven aan uw klanten.",
            "contactDetailsTitle": "Contactgegevens",
            "contactDetailsSubTitle": "Gebruik contactgegevens waar u post kunt ontvangen.",
            "socialDetailsTitle": "Web- en socialgegevens",
            "socialDetailsSubTitle": "Gebruik web- en socialinformatie om deze overal weer te geven.",
            "nameChangedModalTitle": "Waarschuwing!",
            "nameChangedModalSubTitle": "Het wijzigen van de organisatienaam heeft invloed op hun volledige {{businessType}}, en hun klanten herkennen hen mogelijk niet meer aan de oude naam en boekingslink.",
            "stripePaymentSectionTitle": "Accepteer online betalingen via Stripe",
            "stripePaymentSectionSubTitle": "Voeg hier uw Stripe-bedrijfsaccount toe om online betalingen te accepteren en rechtstreeks op uw rekening betaald te krijgen. Beheer alles vanuit één app.",
            "enableStripePaymentsTitle": "Betalingen via Stripe inschakelen",
            "enableStripePaymentsSubTitle": "Door dit in te schakelen, gaat u ermee akkoord dat alle betalingen en terugbetalingen automatisch worden afgehandeld tussen u en uw klant via uw Stripe-account.",
            "stripeAccountIdTitle": "Naam op de Stripe-account-ID",
            "stripeAccountIdPlaceholder": "bijv. Bookzy Incorporation",
            "stripeEmailAccountTitle": "E-mail op de Stripe-account",
            "stripeAccountCountryTitle": "Land op de Stripe-account",
            "enableStripePaymentsBtn": "Mijn Stripe-account toevoegen",
            "enablePaymentMethodsTitle": "Betaalmethoden inschakelen",
            "enablePaymentMethodsSubTitle": "Selecteer de betaalmethoden die u wilt aanbieden voor online betalingen. Er geldt een kleine verwerkingsvergoeding per methode die automatisch wordt afgetrokken van elke transactie. Houd hier rekening mee bij het bepalen van uw ticketprijzen.",
            "paymentProcessingFeeSubTitle": "Verwerkingskosten betaling: {{processingFee}}",
            "payoutScheduleTitle": "Uitbetalingsschema",
            "availableForPayout": "Beschikbaar voor uitbetaling",
            "payoutNow": "Nu uitbetalen",
            "nextPayout": "Volgende uitbetaling gepland op",
            "nextPayoutEstimate": "Schatting. Stripe slaat weekenden en feestdagen over en betaalt alleen een verwerkt saldo uit.",
            "noAvailableBalance": "Nog niets om uit te betalen. Recente verkopen blijven in behandeling tot Stripe ze verwerkt.",
            "payoutsNotEnabled": "Uitbetalingen zijn nog niet ingeschakeld op uw Stripe-account.",
            "payoutStartedTitle": "Uitbetaling onderweg",
            "payoutScheduleSubTitle": "Kies hoe vaak u uitbetalingen wilt ontvangen. Sommige uitbetalingsschema's kunnen een vertragingsperiode bevatten. Houd hier rekening mee bij het beheren van uw cashflow.",
            "subscriptionInformationTitle": "Abonnementsinformatie",
            "subscriptionTableProduct": "Product",
            "subscriptionTableFrequency": "Frequentie",
            "subscriptionTableNextinvoice": "Volgende factuur",
            "tableActionHead": "Actie",
            "noSubscriptionFound": "Geen abonnement gevonden",
            "tryForFree": "Probeer gratis"
          },

          organization: "Organisatie",
          onlinePayment: "Online betaling",

          profile: {
            "fullName": "Volledige naam",
            "dateOfbirth": "Geboortedatum",
            "gender": "Geslacht",
            "SelectGender": "Selecteer geslacht",
            "male": "Man",
            "female": "Vrouw",
            "other": "Anders",
            "address": "Adres",
            "city": "Stad",
            "country": "Land",
            "selectCountry": "Selecteer land",
            "bio": "Biografie",
            "occupation": "Beroep",
            "company": "Bedrijf",
            "website": "Website"
          },

          billing: {
            "billing": "Facturering",
            "invoice": "Factuur",
            "invoiceSubTitle": "Uw Stripe-abonnementsfactuur.",
            "invoiceTableHead": "Factuurnummer",
            "amountTableHead": "Bedrag",
            "invoicePeriodTableHead": "Factuurperiode",
            "detailedReportTableHead": "Gedetailleerd rapport",
            "downloadPDFBtn": "PDF downloaden",
            "noInvoiceFoundMsg": "Geen factuur gevonden"
          },

          myEvents: {
            "createEvent": "Nieuw evenement aanmaken",
            "addNewEvent": "Voeg een nieuw evenement toe",
            "exitCreateNewEvent": "Nieuw evenement verlaten",
            "exitCreateNewEventSubTitle": "U staat op het punt de pagina voor een nieuw evenement te verlaten. Als u nu weggaat, wordt alle ingevoerde informatie verwijderd.",
            "exitCreateNewEventBtn": "Opslaan als concept",
            "exitCreateNewEventDiscardBtn": "Verwijderen",
            "eventName": "Naam van het evenement",
            "tagLine": "Slogan",
            "eventType": "Type evenement",
            "selectEventType": "Selecteer type evenement",
            "aboutThisEvent": "Over dit evenement",
            "aboutThisEventPlaceholder": "Voeg een beschrijving toe van dit evenement en wat de deelnemers kunnen verwachten...",
            "aboutThisEventPlaceholder2": "Beschrijf de sfeer van uw evenement en wat gasten zullen ervaren…",
            "generating": "Bezig met genereren...",
            "generateByAIBtn": "Genereer met AI",
            "duration": "Duur",
            "selectDuration": "Selecteer duur",
            "whatToCarry": "Wat mee te nemen (optioneel)",
            "eventSchedule": "Evenementschema",
            "eventScheduleDates": "Evenementschema datum(s)",
            "oneTime": "Eenmalig",
            "dailyRecurrent": "Dagelijks terugkerend",
            "weeklyRecurrent": "Wekelijks terugkerend",
            "selectDays": "Selecteer dagen",
            "eventDate": "Evenementsdatum",
            "startDate": "Startdatum",
            "time": "Tijd",
            "where": "Waar",
            "endDate": "Einddatum",
            "endDateHelperText": "Eenmalige evenementen hebben geen einddatum",
            "from": "Van",
            "till": "Tot",
            "eventVenue": "Evenementenlocatie",
            "venueAddress": "Adres locatie",
            "location": "Locatie",
            "selectLocation": "Selecteer locatie",
            "eventTickets": "Evenementtickets",
            "addTicketType": "Tickettype toevoegen",
            "ticketType": "Tickettype",
            "price": "Prijs",
            "capacity": "Capaciteit",
            "totalCapacity": "Totale capaciteit:",
            "ticketsSold": "Verkochte tickets",
            "totalTicketsSold": "Totaal verkochte tickets",
            "costToBuyer": "Kosten voor koper:",
            "excluding": ", exclusief",
            "including": ", inclusief",
            "serviceFee": "servicekosten",
            "yourPayout": "Jouw uitbetaling:",
            "salesPeriod": "Verkoopperiode",
            "salesPeriodHelper": "Wanneer dit tickettype gekocht kan worden. Buiten deze data is het niet zichtbaar in de shop.",
            "excludingGatewayFees": ", exclusief transactiekosten",
            "dietarySplitTitle": "Dieetwensen",
            "dietarySplitSubtitle": "Alleen bevestigde gasten. Geannuleerde boekingen tellen niet mee.",
            "dietarySplitAttendees": "{{total}} gasten",
            "dietaryNotApplicable": "Dieetwensen niet van toepassing",
            "dietaryTotal": "Totaal",
            "dietaryNotAsked": "Niet gevraagd {{notAsked}}",
            "includedAddonRenameWarning": "Al verkochte tickets behouden de naam \"{{savedName}}\". In rapportages verschijnen de oude en nieuwe naam als twee losse items.",
            "noTicketsCreated": "Geen tickets aangemaakt",
            "multipleTickets": "(Meerdere tickets)",
            "deleteTicketTypeTitle": "Tickettype verwijderen",
            "deleteTicketTypeSubTitle": "Weet u zeker dat u dit tickettype wilt verwijderen?",
            "addTicket": "Ticket toevoegen",
            "add": "Toevoegen",
            "tickets": "Tickets",
            "startDateTimeBeforeEndTime": "De starttijd moet vóór de eindtijd liggen",
            "endDateTimeAfterStartTime": "De eindtijd moet na de starttijd liggen",
            "minCapacityOfTicket": "De capaciteit van dit ticket moet minstens gelijk zijn aan de reeds geboekte capaciteit.",
            "addonNameErrorMsg": "Extra {{number}}: \"Naam\" is een verplicht veld",
            "addonQtyErrorMsg": "Extra {{number}}: \"Aantal\" moet een positief getal zijn en minimaal 1",
            "ticketTypeHelperText": "Voer een tickettype in dat prijs en toegangsrechten onderscheidt",
            "priceTooltipTitle": "Houd rekening met platform- en betalingskosten bij het bepalen van de ticketprijs",
            "free": "Gratis",
            "paymentNotEnabledTitle": "Online betaling niet ingeschakeld",
            "paymentNotEnabledSubTitle": "Voordat je betaalde tickets kunt verkopen, moet je online betalingen inschakelen.",
            "paymentNotEnabledBtn": "Online betaling activeren",
            "absorbServiceFee": "Servicekosten opnemen",
            "minimumBookingQty": "Aantal tickets per bestelling",
            "minimumBookingQtyHelperText": "Gasten kunnen alleen in veelvouden van dit aantal kopen. Bijv. stel in op 2 voor koppeldeals, 4+ voor groepsdeals.",
            "capacityHelperText": "aantal tickets voor deze prijs",
            "availableForSale": "Beschikbaar voor verkoop",
            "addIncludedItemsTitle": "Inclusieve items toevoegen",
            "addIncludedItemsSubTitle": "(bijv. Gratis drankje, T-shirt, maaltijd)",
            "addIncludedItemsSubTitle2": "Elk item genereert een unieke QR-code die kan worden gescand en ingewisseld op de locatie.",
            "addonName": "Naam extra",
            "qty": "Aantal",
            "addMore": "+ Meer toevoegen",
            "advanceSettings": "Geavanceerde instellingen",
            "showEndDateOnShop": "Toon de einddatum in de webshop?",
            "startTime": "Starttijd",
            "selectStartTime": "Selecteer starttijd",
            "general": "Algemeen",
            "addons": "Extra's",
            "eventSettings": "Evenementinstellingen",
            "schedule": "Schema",
            "reviewPublish": "Beoordelen en publiceren",
            "eventAddons": "Evenement add-ons",
            "addNewAddon": "Nieuwe add-on toevoegen",
            "addonType": "Type add-on",
            "selectAddonType": "Selecteer type add-on",
            "description": "Beschrijving",
            "addDescription": "Beschrijving toevoegen",
            "addonPhoto": "Foto van add-on",
            "changeImage": "Afbeelding wijzigen",
            "addImage": "Afbeelding toevoegen",
            "addPhoto": "Foto toevoegen",
            "changeBanner": "Evenementbanner bewerken",
            "addBanner": "Evenementbanner toevoegen",
            "maxQtyPerTicket": "Maximaal toegestaan aantal per ticket",
            "priceOnline": "Prijs online",
            "priceAtVenue": "Prijs op locatie",
            "priceAtVenueHelperText": "Prijs voor add-on op locatie",
            "addAddon": "Add-on toevoegen",
            "addonCapacityMustBeBooking": "De capaciteit van deze add-on moet minimaal gelijk zijn aan de reeds geboekte capaciteit.",
            "sameAddonType": "Zelfde type add-on is niet toegestaan!",
            "removeAddonTitle": "Add-on verwijderen",
            "removeAddonDefaultMsg": "Weet u zeker dat u deze {{type}} wilt verwijderen?",
            "noAddonsCreated": "Geen add-ons aangemaakt",
            "freeCancellation": "Gratis annulering",
            "periodBeforeCancellationAllowed": "Periode vóórdat gratis annuleren is toegestaan:",
            "cancellationCharge": "Annuleringskosten",
            "noFreeCancellationAllowed": "Geen gratis annulering toegestaan",
            "privateEvent": "Privé-evenement",
            "privateEventTooltip": "Maak dit evenement privé als u alleen geselecteerde personen wilt laten boeken",
            "privateEventMsg1": "Alleen klanten met een uitnodigingscode kunnen dit evenement boeken.",
            "privateEventMsg2": "De uitnodigingscode is te vinden in de evenementdetails zodra deze is aangemaakt",
            "orderLimit": "Bestellimiet",
            "maxTicketsAllowedPerOrder": "Maximaal aantal tickets per bestelling",
            "maxTicketsAllowedPerOrderPlaceholder": "Aantal max. tickets per bestelling",
            "noLimitInSingleOrder": "geen limiet voor het aantal tickets per bestelling",
            "allowFreeCancellation": "Gratis annulering toestaan",
            "allowFreeCancellationText": "Gratis annulering wordt aanbevolen",
            "bookingOnlyByInviteCode": "Boeken alleen met uitnodigingscode",
            "qtyPerTicket": "Aantal per ticket",
            "addonsBooked": "Boekingen van add-ons",
            "privateEventStatus": "Privé-evenement",
            "publicEventStatus": "Publiek evenement",
            "eventCanBookedByAnybody": "Dit evenement kan door iedereen geboekt worden",
            "eventCanBookedByAnybody2": "Publiek evenement. Dit evenement kan door iedereen geboekt worden",
            "cancellationPolicyTitle": "Annuleringsbeleid",
            "cancellationPolicyMsg1": "Annuleringskosten van",
            "cancellationPolicyMsg2": "zijn van toepassing op alle annuleringen. Geen restitutie bij annulering binnen",
            "cancellationPolicyMsg3": "voor aanvang van het evenement",
            "freeCancelationNotAvailable": "Gratis annuleren niet beschikbaar.",
            "maxTicketsPerOrderMsg1": "Klanten kunnen maximaal",
            "maxTicketsPerOrderMsg2": "tickets per bestelling kopen",
            "maxTicketsPerOrderTitle": "Maximaal aantal tickets per bestelling",
            "createdEventStep1": "Evenementindeling aangemaakt",
            "createdEventStep2": "Prijzen aangemaakt",
            "createdEventStep3": "Schema('s) aangemaakt voor dit evenement",
            "savingInDraft": "Opslaan als concept",
            "creatingBookingLink": "Boekingslink maken",
            "createdEventSucc1": "Gefeliciteerd!",
            "createdEventSucc2": "Uw evenement is nu klaar voor boekingen",
            "shareTheLinkBelowMsg": "Deel de onderstaande link om klanten te laten boeken",
            "copy": "Kopiëren",
            "copied": "Gekopieerd!",
            "failedToCopy": "Kopiëren mislukt!",
            "addAnotherEvent": "Nog een evenement toevoegen",
            "gotoMyEvents": "Ga naar mijn evenementen",
            "createPublish": "Evenement aanmaken & publiceren",
            "orders": "Bestellingen",
            "addOns": "Extra’s",
            "revenue": "Omzet",
            "cancelingRefundMsg": "Het annuleren van dit evenement zal de betreffende kosten terugbetalen aan alle deelnemers indien reeds betaald. Weet je zeker dat je deze les wilt annuleren?",
            "cancelSingleSessionMsg": "Je kunt geen enkele sessie van deze cursus annuleren",
            "classInstanceIsCancelled": "Deze lesinstantie is geannuleerd",
            "eventPageLink": "Evenementpagina link",
            "classHasMultipleInstances": "Deze les heeft meerdere sessies",
            "venue": "Locatie",
            "payAtVenue": "Betalen op locatie",
            "actions": "Acties",
            "editEventDetails": "Evenementdetails bewerken",
            "changeSchedule": "Schema wijzigen",
            "shareScanTicketToken": "Scan-ticketcode delen",
            "issueComplementaryTicket": "Gratis ticket uitgeven",
            "cancelEvent": "Evenement annuleren",
            "editEvent": "Evenement bewerken",
            "pickAnotherInstance": "Andere sessie kiezen",
            "preview": "Voorbeeld",
            "imagePreview": "Afbeeldingsvoorbeeld",
            "embedBookingWidget": "Boekingswidget insluiten",
            "embedBookingWidgetCode": "Boekingswidgetcode",
            "eventMetrics": "Evenementstatistieken",
            "allSalesChannels": "Alle verkoopkanalen",
            "totalAddonsSold": "Totaal verkochte add-ons",
            "totalRevenue": "Totale omzet",
            "ticketsRevenue": "Inkomsten uit tickets",
            "addonsRevenue": "Inkomsten uit add-ons",
            "commission": "Commissie",
            "eventActivityOverTime": "Evenementsactiviteit in de tijd",
            "daily": "Dagelijks",
            "weekly": "Wekelijks",
            "monthly": "Maandelijks",
            "splitByTicketType": "Op tickettype splitsen",
            "ticketsBooked": "Geboekte tickets",
            "splitByAddonsType": "Op type add-on splitsen",
            "addonsSold": "Verkochte add-ons",
            "seeMore": "...meer weergeven",
            "seeLess": "...minder weergeven",
            "whatToCarryTitle": "Wat mee te nemen",
            "cancelationPolicy": "Annuleringsbeleid",
            "selectEndTime": "Selecteer eindtijd",
            "cancelSession": "Sessie annuleren",
            "bookingLinkGeneratedTitle": "Boekingslink voor {{eventName}}",
            "bookingLinkGeneratedSubTitle": "Boekingslink aangemaakt",
            "scanTicketTokenTitle": "Scan-ticketcode voor {{eventName}}",
            "scanTicketTokenSubTitle": "Deel en gebruik deze code in de Scan-app om tickets te valideren",
            "enterAtLeastOneQuantity": "Voer minimaal één hoeveelheid in.",
            "reachedItsMaxCapacity": "Het geselecteerde tickettype heeft de maximale capaciteit bereikt.",
            "selectTicket": "Selecteer ticket",
            "quantity": "Hoeveelheid",
            "issueTicket": "Ticket uitgeven",
            "salesDistribution": "Verkoopverdeling",
            "ticketsDistribution": "Ticketverdeling",
            "addonsDistribution": "Add-onverdeling",
            "revenueDistribution": "Omzetverdeling",
            "commissionBreakdown": "Commissiespecificatie",
            "appliedThreshold": "Toegepaste drempel",
            "tier": "Niveau",
            "rate": "Tarief",
            "of": "van",
            "ticket": "Ticket",
            "total": "Totaal",
            "bonusEarned": "Bonus verdiend",
            "totalPayout": "Totale uitbetaling (bonus + commissie)",
            "editBasicInfo": "Basisinfo bewerken",
            "editSettings": "Instellingen bewerken",
            "invitecode": "Uitnodigingscode:",
            "sameSellerNotAllow": "Dezelfde verkoper kan niet worden gebruikt voor verschillende verkoopkanalen",
            "tierTicketsSoldErrorMsg": "Niveau {{number}}: \"Verkochte tickets\" moet een positief getal zijn",
            "tierFromErrorMsg": "Niveau {{number}}: \"Vanaf\" moet een positief getal zijn",
            "tierCommissionErrorMsg": "Niveau {{number}}: \"Commissie per ticket\" moet een geldig getal zijn",
            "tierToFromErrorMsg": "Niveau {{number}}: \"Tot\" moet groter zijn dan \"Vanaf\"",
            "tierPreviousTierErrorMsg": "Niveau {{number}}: \"Verkochte tickets\" moet groter zijn dan de drempel van het vorige niveau",
            "tierOverlappingErrorMsg": "Niveau {{number}}: Overlappende reeks met vorig niveau",
            "tierRangeMustContinueErrorMsg": "Niveau {{number}}: Reeks moet doorgaan vanaf vorig niveau (verwacht \"Vanaf\" = {{to}})",
            "completeThePreviousTierErrorMsg": "Voltooi het vorige niveau voordat u een nieuw niveau toevoegt.",
            "eventSalesChannel": "Evenement verkoopkanaal",
            "addSalesChannel": "Verkoopkanaal toevoegen",
            "campaign": "Campagne",
            "selectCampaign": "Selecteer een campagne",
            "noCampaignsForEvent": "Nog geen campagnes voor dit evenement. Maak er een aan in Promoties om het commissiemodel te bepalen.",
            "howToAdd": "Hoe wil je ze toevoegen?",
            "modeInvite": "Stuur een uitnodiging",
            "modeInviteDesc": "Ze maken zelf hun account & uitbetalingen aan.",
            "modeManaged": "Direct toevoegen (ik beheer)",
            "modeManagedDesc": "Het kanaal wordt nu aangemaakt; we mailen hun verkooplink. Je verrekent de commissie handmatig.",
            "selectSellers": "Selecteer verkopers",
            "sellersSelected": "geselecteerd",
            "addSellers": "Verkopers toevoegen",
            "sendInvites": "Uitnodigingen versturen",
            "sellersAdded": "Verkopers toegevoegd — hun links zijn gemaild.",
            "invitesSent": "Uitnodigingen verzonden.",
            "dashboardLinkSent": "Dashboardlink verzonden.",
            "manageInPromotions": "Beheer verkopers via Mijn promoties",
            "copySellingLink": "Kopieer verkooplink",
            "sendTrackLink": "Stuur 'Volg mijn verkopen'-link",
            "sellerName": "Naam verkoper",
            "commissionType": "Type commissie",
            "channelType": "Type kanaal",
            "ref": "Ref:",
            "noSalesChannelCreated": "Geen verkoopkanaal aangemaakt",
            "deleteSalesChannel": "Verkoopkanaal verwijderen",
            "deleteSalesChannelSubtitle": "Weet u zeker dat u dit verkoopkanaal wilt verwijderen?",
            "updateSalesChannel": "Verkoopkanaal bijwerken",
            "salesChannelAdded": "Verkoopkanaal toegevoegd",
            "salesChannelAddedSubTitle": "Uw verkoopkanaal is succesvol toegevoegd.",
            "seller": "Verkoper",
            "selectSeller": "Selecteer verkoper",
            "addBannerImageBtn": "Aangepaste banner toevoegen",
            "addBannerImageTitle": "Evenementbanner van verkoper",
            "addBannerImageSubTitle": "Deze banner wordt weergegeven aan klanten wanneer zij via de link van uw verkoopspartner kopen",
            "addCommissionModel": "Commissiemodel toevoegen",
            "commissionModelType": "Type commissiemodel",
            "flat": "Vast",
            "tiered": "Gelaagd",
            "thresholdBased": "Op drempel gebaseerd",
            "commissionModelTypeFlatHelper": "Enkel commissiepercentage toegepast op alle verkochte tickets.",
            "commissionModelTypeTieredHelper": "Commissie wordt berekend met progressieve niveaus, waarbij het tarief van elk niveau alleen geldt voor de verkopen binnen dat niveau.",
            "commissionModelTypeThresholdHelper": "Commissiepercentage wordt toegepast op alle verkochte tickets op basis van de bereikte drempel.",
            "commissionUnitType": "Type commissie-eenheid",
            "entervalue": "Voer waarde in",
            "thresholds": "Drempels",
            "tiers": "Niveaus",
            "greaterThan": "groter dan",
            "equalTo": "gelijk aan",
            "to": "Tot",
            "min": "Min",
            "max": "Max",
            "addThreshold": "+ Drempel toevoegen",
            "addTier": "+ Niveau toevoegen",
            "addBonus": "Bonus toevoegen",
            "bonusThreshold": "Bonus drempel",
            "bonusAmount": "Bonus bedrag",
            "noCommission": "Geen commissie"
          },

          myPromotions: {
            "payViaStripe": "Betaal via Stripe",
            "payPromoter": "Betaal promotor",
            "payOnlineStripe": "Online betalen (via Stripe)",
            "markPaidOffline": "Offline als betaald markeren",
            "noStripeHint": "Promotor heeft geen gekoppeld Stripe-account.",
            "payoutRequests": "Uitbetalingsverzoeken",
            "pendingRequests": "Openstaande verzoeken",
            "paymentsHistory": "Betalingsgeschiedenis",
            "method": "Methode",
            "methodStripe": "Stripe",
            "methodOffline": "Offline",
            "initiatedBy": "Geïnitieerd door",
            "initiationDate": "Initiatiedatum",
            "dateOfPayment": "Betaaldatum",
            "paymentMethod": "Betaalmethode",
            "methodPaidOnline": "Online betaald",
            "paymentStatus": "Status",
            "statusConfirmed": "Bevestigd",
            "statusPendingConfirmation": "Wacht op bevestiging",
            "statusDisputed": "Betwist",
            "initPromoter": "Promotor",
            "initOrganizer": "Organisator",
            "initSellerRequest": "Op verzoek",
            "reqRequested": "Aangevraagd",
            "reqAmount": "Bedrag",
            "reqStatus": "Status",
            "reqAction": "Actie",
            "statusPending": "In afwachting",
            "statusPaid": "Betaald",
            "statusDeclined": "Afgewezen",
            "pay": "Betaal",
            "decline": "Afwijzen",
            "syncStripePayouts": "Stripe-uitbetalingen synchroniseren",
            "syncStripePayoutsHint": "Haal voltooide Stripe-uitbetalingen op die nog niet zichtbaar zijn.",
            "syncing": "Synchroniseren…",
            "payoutsSynced": "Uitbetalingen gesynchroniseerd",
            "payoutsUpToDate": "Al up-to-date.",
            "payout": "Uitbetaling",
            "viaStripe": "via Stripe",
            "markPaidManually": "Offline als betaald markeren",
            "stripePayoutSuccess": "Uitbetaling voltooid. Het kan even duren voordat dit zichtbaar is.",
            "stripePayoutCancelled": "Uitbetaling geannuleerd.",
            "requestedPayout": "Aangevraagd",
            "sellerRequestedPayout": "Verkoper heeft uitbetaling aangevraagd",
            "useActionsToSettle": "gebruik de knop Uitbetaling om af te rekenen",
            "requestDeclined": "Uitbetalingsverzoek afgewezen.",
            "declineRequest": "Uitbetalingsverzoek afwijzen",
            "trackingOnly": "Alleen tracking",
            "trackingOnlyHint": "Alleen tracking — verkopen worden toegewezen aan dit kanaal, geen commissie of uitbetaling.",
            "noCommissionTracking": "Geen commissie (alleen tracking)",
            "noCommissionHint": "Maak een deelbare trackinglink (bijv. voor Instagram) zonder commissie of uitbetaling. Verkopen worden nog steeds aan dit kanaal toegewezen.",
            "createNewPromotion": "Nieuwe promotie aanmaken",
            "noPromotionsConfigured": "Nog geen promoties geconfigureerd",
            "addNewPromotion": "Nieuwe promotie toevoegen",
            "updatePromotion": "Promotie bijwerken",
            "selectEvent": "Selecteer evenement",
            "offerLabel": "Aanbod naam",
            "offerLabelPlaceholder": "bijv. Aanbod A, Vroege vogel commissie",
            "maxSellers": "Max verkopers",
            "enrolled": "Ingeschreven",
            "viewPerformance": "Bekijken",
            "invite": "Uitnodigen",
            "addBanner": "Aangepaste banner toevoegen",
            "changeBanner": "Aangepaste banner wijzigen",
            "bannerSaved": "Banner opgeslagen.",
            "bannerRemoved": "Banner verwijderd.",
            "ended": "Beëindigd",
            "endedHint": "Deze campagne is beëindigd — bewerk deze om te heractiveren voordat je verkopers toevoegt of inschakelt.",
            "pausedHint": "Deze campagne is gepauzeerd — heractiveer deze voordat je verkopers toevoegt of inschakelt.",
            "alreadyAdded": "Al toegevoegd",
            "noEmail": "Geen e-mail",
            "noEmailHint": "Voeg een e-mail toe aan deze verkoper om uit te nodigen",
            "sellerSingular": "verkoper",
            "scrollForMore": "Scroll voor meer",
            "doubleClickPerformance": "Dubbelklik om prestaties te bekijken",
            "revenue": "Omzet",
            "commission": "Commissie",
            "costPerTicket": "Kosten/ticket",
            "sellers": "Verkopers",
            "orders": "Bestellingen",
            "ticketRevenue": "Ticketomzet",
            "addonRevenue": "Add-on omzet",
            "unattributed": "niet toegewezen",
            "noData": "Nog geen prestatiegegevens.",
            "noSellersYet": "Nog geen verkopers voor deze campagne.",
            "payout": "Uitbetaling",
            "commissionToPay": "Te betalen",
            "paid": "Betaald",
            "outstanding": "Openstaand",
            "showBreakdown": "Toon uitsplitsing",
            "hideBreakdown": "Verberg uitsplitsing",
            "payoutCommission": "Uitbetalen",
            "markPaid": "Markeer als betaald",
            "markedPaid": "Gemarkeerd als betaald.",
            "markedPaidAwaitingConfirmation": "Betaling geregistreerd — wacht op bevestiging van verkoper.",
            "awaitingSellerConfirmation": "wacht op bevestiging van verkoper",
            "awaitingSellerConfirmationHint": "De verkoper moet bevestigen dat deze betaling is ontvangen. Wordt automatisch bevestigd na 14 dagen.",
            "pendingConfirmationLabel": "In afwachting",
            "payoutSent": "Uitbetaling verzonden.",
            "enableSeller": "Inschakelen",
            "disableSeller": "Uitschakelen",
            "disabled": "uitgeschakeld",
            "actions": "Acties",
            "viewDetails": "Bekijk details",
            "hideDetails": "Verberg details",
            "after": "na",
            "ticketsSold": "verkochte tickets",
            "shareCampaign": "Campagne delen",
            "sendInvites": "Uitnodigingen versturen",
            "invitesSent": "Uitnodigingen verstuurd!",
            "invitesSentCount": "uitnodiging(en) succesvol verstuurd",
            "selectSellersToInvite": "Selecteer verkopers om uit te nodigen voor deze campagne. Ze ontvangen een e-mail met evenementdetails en commissie-informatie.",
            "noSellersFound": "Geen verkopers met e-mail gevonden. Voeg eerst verkopers toe.",
            "sellersSelected": "verkoper(s) geselecteerd",
            "inviteSellers": "Verkopers uitnodigen",
            "active": "Actief",
            "paused": "Gepauzeerd",
            "campaign": "Campagne",
            "clickToDisable": "Klik om campagne te pauzeren",
            "clickToEnable": "Klik om campagne te activeren",
            "perTicket": "per ticket",
            "bonusAfter": "bonus na",
            "tickets": "tickets",
            "from": "Vanaf",
            "until": "Tot",
            "startDate": "Startdatum",
            "endDate": "Einddatum",
            "endDateBeforeStart": "Einddatum moet na startdatum liggen",
            "inviteTracking": "Uitnodigingen bijhouden",
            "inviteSeller": "Verkoper",
            "inviteEmail": "E-mail",
            "inviteStatus": "Status",
            "inviteSentOn": "Verstuurd op",
            "statusInvited": "Uitgenodigd",
            "statusAccepted": "Geaccepteerd",
            "statusUsed": "Gebruikt",
            "statusDeclined": "Afgewezen",
            "statusExpired": "Verlopen",
            "loadingInvites": "Uitnodigingen laden…",
            "noTicketSales": "Nog geen tickets verkocht.",
            "noAddonSales": "Geen add-ons verkocht."
          },

          myschedule: {
            "loadingSessionDetails": "Sessiedetails laden",
            "noEventsConfigured": "Geen evenementen geconfigureerd",
            "allTab": "Alles",
            "publishedTab": "Gepubliceerd",
            "draftsTab": "Concepten",
            "cancelledtab": "Geannuleerd",
            "pastTab": "Verleden",
            "ticketsSold": "Tickets verkocht",
            "markAsDraft": "Markeren als concept",
            "markAsPublished": "Markeren als gepubliceerd",
            "duplicatecreate": "Dupliceren en maken",
            "noEventsAvailable": "Geen evenementen beschikbaar."
          },

          bookings: {
            "bookingTitle": "Boekingen",
            "recentBookingTitle": "Recente boekingen",
            "totalBookingTitle": "Totale boekingen",
            "bookingId": "Boekings-ID",
            "ticketsBought": "Tickets gekocht",
            "amountPaid": "Betaald bedrag",
            "seatsBooked": "Stoelen gereserveerd",
            "sendTikkie": "Stuur Tikkie",
            "markAsPaid": "Markeren als betaald",
            "cancelBooking": "Boeking annuleren",
            "contact": "Contact",
            "warning": "WAARSCHUWING",
            "changePaidStatusMsg": "De betalingsstatus kan niet worden teruggezet naar onbetaald. Weet u zeker dat u de status wilt wijzigen naar betaald?",
            "cancelBookingMsg": "Annulering leidt tot volledige terugbetaling aan de klant. Weet u zeker dat u deze boeking wilt annuleren?",
            "cancelBookingDialogMsg": "Weet u zeker dat u de boeking wilt annuleren?",
            "removedParticipant": "Deelnemer verwijderd",
            "enabledYourPaymentSettings": "U heeft uw betalingsinstellingen niet ingeschakeld. Wilt u deze nu instellen?",
            "paymentLinkGeneratedTitle": "Betaallink voor {{eventName}}",
            "paymentLinkGeneratedSubTitle": "Betaallink gegenereerd",
            "noBookingsYet": "Nog geen boekingen",
            "customerNeverPaidForIt": "Klant heeft hiervoor nooit betaald",
            "itWasAFreeService": "Het was een gratis dienst",
            "unknown": "ONBEKEND",
            "bookingStatus": "Boekingsstatus",
            "bookingDate": "Boekingsdatum",
            "cancellationDate": "Annuleringsdatum",
            "paymentStatus": "Betalingsstatus",
            "customerDetails": "Klantgegevens",
            "purchaseDetails": "Aankoopgegevens",
            "activityBooked": "Geboekte activiteit",
            "activityStatus": "Activiteitsstatus",
            "activityDate": "Activiteitsdatum",
            "complementaryTicket": "(Gratis ticket)",
            "addonsBought": "Extra's gekocht",
            "paymentMethod": "Betaalmethode",
            "totalAmountPaid": "Totaal betaald bedrag",
            "includingVATFee": "Inclusief BTW & servicekosten",
            "yourPayoutDetails": "Uw uitbetalingsgegevens",
            "amountCustomerPaid": "Bedrag betaald door klant",
            "platformServiceFee": "Platformservicekosten",
            "paymentProcessingFee": "Verwerkingskosten betaling",
            "expectedPayout": "Verwachte uitbetaling",
            "beforePaymentProcessingFeeMsg": "(Voor aftrek van verwerkingskosten door de betalingsprovider)",
            "bookingDetailsSentTitle": "Boekingsdetails verzonden",
            "bookingDetailsSentSubTitle": "Er is een e-mail met boekingsdetails en tickets verzonden naar {{email}}",
            "emailBookingDetails": "Boekingsdetails e-mailen",
            "downloadBookingDetails": "Boekingsdetails downloaden",
            "yourRefundDetails": "Uw terugbetalingsgegevens",
          },

          mySellers: {
            "addNewSellers": "Nieuwe verkopers toevoegen",
            "noSellersConfigured": "Geen verkopers geconfigureerd",
            "copyOnBordingLink": "Onboarding-link kopiëren",
            "removeSeller": "Verkoper verwijderen",
            "noServicesAreAvailable": "Geen services beschikbaar",
            "sellersName": "Naam van verkoper",
            "sellerType": "Type verkoper",
            "selectSellerType": "Selecteer type verkoper",
            "addPaymentAccount": "Betalingsaccount toevoegen",
            "addPaymentAccountHelperTest": "Er wordt een link verzonden via e-mail om verkopersaccountinformatie in te dienen. Zodra dit is voltooid, wordt de status hier automatisch bijgewerkt",
            "paymentAccountDetails": "Betalingsaccountgegevens",
            "paymentAccountId": "Betalingsaccount-ID",
            "status": "Status:",
            "active": "Actief",
            "pending": "In behandeling",
            "bankSccountDetailsMessage": "Het account-ID is aangemaakt, maar aanvullende verkopersinformatie en bankgegevens zijn nog vereist.",
            "resendOnboardingLink": "Onboarding-link opnieuw verzenden"
          },

          mySubscription: {
            "mySubscriptionTitle": "Mijn abonnement",
            "subscribSuccTitle": "Je bent helemaal klaar",
            "subscribSuccSubTitle": "Laten we nu die evenementen op gang brengen!",
            "startFree": "Gratis starten",
            "startFreeTrial": "Start je 30 dagen gratis proefperiode",
            "upgradeSubscription": "Abonnement upgraden",
            "currentSubscription": "Huidig abonnement",
            "addingHostDetail": "Hostgegevens toevoegen",
            "addingOrgDetail": "Organisatiegegevens toevoegen",
            "freeTrialDetail": "Gratis proefperiode"
          },

          dashboard: {
            "dashboard": "Dashboard",
            "customer": "Klant",
            "activityBooked": "Activiteit geboekt"
          },

          successes: {
            "success": "Succes!",
            "subscribSuccessfully": "Uw abonnement is succesvol geüpgraded",
            "passwordSuccessfully": "Uw wachtwoord is succesvol gewijzigd",
            "profileSuccessfully": "Uw profiel is succesvol bijgewerkt",
            "businessProfileSuccessfully": "Uw bedrijfsprofiel is succesvol bijgewerkt",
            "passwordSuccessfullyTitle": "Wachtwoord succesvol gewijzigd",
            "passwordSuccessfullySubTitle": "Uw wachtwoord is succesvol bijgewerkt.",
            "paymentProfileChangedSuccTitle": "Profiel succesvol gewijzigd",
            "paymentProfileChangedSuccSubTitle": "{{profileType}}-profiel succesvol bijgewerkt!",
            "paymentProfileChangedSuccSubTitle2": "Uitbetalingsschema succesvol bijgewerkt!",
            "paymentProfileAddedSuccTitle": "Goed gedaan!",
            "paymentProfileAddedSuccSubTitle": "Uw klanten kunnen u nu rechtstreeks op uw rekening betalen.",
            "paymentProfileAddedSuccBtn": "Ga terug naar Dashboard",
            "goBackToLoginBtn": "Ga terug naar Inloggen"
          },

          // Existing error messages
          errors: {
            "required": "Verplicht!",
            "isRequired": "{{field}} is verplicht",
            "invalid": "{{field}} is ongeldig",
            "validationGeneralError": "Corrigeer de onderstaande fouten",

            "passwordSyntax": "Moet minimaal 8 tekens bevatten",
            "passwordNOTMatch": "Wachtwoorden komen niet overeen",
            "incorrectCode": "Onjuiste code, probeer het opnieuw",
            "somethingIsWrong": "Er is iets misgegaan, probeer het later opnieuw",
            "aboutusMinLength": "Voer minimaal 5 tekens in om uw {{businessName}} te beschrijven",
            "invalidPhoneNumber": "Voer een geldig telefoonnummer in",
            "invalidEmail": "Voer een geldig e-mailadres in",
            "subscriptionWarningMsg": "U heeft geen actief abonnement. Om toegang te krijgen tot {{businessType}}, moet u een abonnement aanschaffen of upgraden.",
            "invalidWURL": "Voer een geldige website-URL in",
            "invalidFURL": "Voer een geldige Facebook-URL in",
            "invalidIURL": "Voer een geldige Instagram-URL in",
            "invalidYURL": "Voer een geldige YouTube-URL in",
            "invalidLURL": "Voer een geldige LinkedIn-URL in",
            "invalidTURL": "Voer een geldige Twitter-URL in",
            "onePaymentMethodRequired": "Er moet minimaal één betaalmethode zijn ingeschakeld",
            "connectWithStripeAcc": "Verbind een Stripe-account",
            "errorOccurredTitle": "Er is een fout opgetreden",
            "errorOccurredSubTitle": "Kan Stripe-account niet aanmaken: De opgegeven informatie kon niet worden geverifieerd. Controleer uw gegevens en probeer het opnieuw.",
            "errorOccurredBtn": "Ga terug",
            "delayMustBeMsg": "De minimale vertraging moet 7 dagen zijn",
            "monthlyAnchorMustBeMsg": "De maandelijkse ankerwaarde moet tussen 1 en 31 liggen",
            "decimalValueOnly": "Voer een decimale waarde in",
            "endDateErrorMsg": "Einddatum moet na de startdatum liggen",
            "startDateErrorMsg": "Startdatum moet in de toekomst liggen",
            "locationRequiredErrorMsg": "Locatie is verplicht",
            "startApartMinuteErrorMsg": "Start- en eindtijden moeten minimaal 1 minuut uit elkaar liggen",
            "aiServiceNotAvailable": "Deze service is niet beschikbaar",
            "enterEventNameError": "Voer een evenementnaam in",
            "failedToGenerateDescription": "Beschrijving genereren mislukt",
            "errorAddingLocation": "Fout bij het toevoegen van locatie",
            "addAtLeastOnePrice": "Voeg minimaal één prijs toe",
            "completePreAddons": "Voltooi de vorige add-on details voordat u een nieuwe toevoegt",
            "positiveQtyNumber": "\"Aantal\" moet een positief getal zijn, met minimaal 1 vereist",
            "enterValidEmail": "Voer een geldig e-mailadres in",
            "notAllowSameTicketType": "Hetzelfde tickettype is niet toegestaan!",
            "priceLessThanServiceFee": "Ticketprijs moet minimaal {{serviceFee}} zijn om de servicekosten te dekken bij absorptie.",
            "venueCannotBeLessThanOnline": "Prijs aan de deur kan niet lager zijn dan de online prijs."
          },
          myGuests: {
            sendNotification: "Melding verzenden",
            promotionalEmail: "Promotionele e-mail",
            sendEmail: "E-mail verzenden",
            guestList: "Gastenlijst",
            title: "Titel",
            promotionalImage: "Promotieafbeelding",
            promotionalMessage: "Promotiebericht",
            lengthExceedError: "Er zijn maximaal 100 e-mailadressen toegestaan",
            filterByEvent: "Filter op evenementnaam...",
          }

          // Add other existing translations here...
        },
      },
    },
  });

export default i18next;